import { Grid } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import PmiTextField from 'shell/components/shared/text-field';
import ListAnsc from 'civil-status/components/shared/list-ansc';
import { useEventCallback } from '@mui/material';
import { ItemVM } from 'shell/view-models/item';

interface AssentSonDataProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  nothingRequired?: boolean;
}

const AssentSonDataComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: AssentSonDataProps): React.ReactElement => {
  const handleListTypeDeclaration = useEventCallback((item?: ItemVM) => {
    onChange('typeDeclaration', item?.id);
  });

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <ListAnsc
          label="Tipo dichiarazione assenso"
          idDominio="37"
          value={values?.typeDeclaration || ''}
          onChange={handleListTypeDeclaration}
          disabled={disabled}
          error={Boolean(errors?.typeDeclaration) && touched?.typeDeclaration}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Assenso reso dinanzi a *"
          aria-label="Assenso reso dinanzi a"
          id="consentReturnedBefore"
          name="consentReturnedBefore"
          fullWidth
          disabled={disabled}
          helperText={errors?.consentReturnedBefore}
          error={touched?.consentReturnedBefore && Boolean(errors?.consentReturnedBefore)}
          type="text"
          variant="outlined"
          value={values?.consentReturnedBefore || ''}
          onChange={(event) => {
            onChange('consentReturnedBefore', event.target.value);
          }}
        />
      </Grid>
    </Grid>
  );
};

AssentSonDataComponent.displayName = 'Form Assent Son Data component';

const AssentSonData = memo(AssentSonDataComponent);

export default AssentSonData;
